const state = {
  step: { tabIndex: 0 },
  journey: [
    'house-type',
    'number-of-bedrooms',
    'occupancy-frequency',
    'modernisation-level',
    'heating-and-cooking'
  ],
  questions: []
};

const getters = {
  progress: (state) => {
    const typeIndex = state.questions.indexOf(state.step);

    return (typeIndex + 1) * 100 / (state.questions.length);
  }
};

const actions = {
  getQuestions ({ commit }, tabChildren) {
    const questions = tabChildren.map((child, tabIndex) => ({ q: child.title, tabIndex }));

    commit('updateQuestions', questions);
  },
  goToQuestion ({ state, commit }, { type }) {
    const questions = state.questions;
    let typeIndex;

    const index = questions.indexOf(state.step);

    if (type === 'next') {
      typeIndex = index + 1;
    }

    if (type === 'prev') {
      typeIndex = index - 1;
    }

    if (type === 'start') {
      typeIndex = 0;
    }

    commit('updateState', { prop: 'step', value: questions[typeIndex] });
  }
};

const mutations = {
  updateState (state, { prop, value }) {
    state[prop] = value;
  },
  updateQuestions (state, questions) {
    const findQuestion = (find) => {
      return questions.find(item => item.q === find);
    };

    state.questions = state.journey.map(item => findQuestion(item));
    state.step = state.questions[0];
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
